PluginChromeView = require 'views/plugin/plugin-chrome-view'

module.exports = class PluginBoardBarView extends PluginChromeView
  initialize: ({ @content }) ->
    @retain(@content)

  className: 'plugin-board-bar'



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-board-bar-view.coffee